import { AppConfig } from '@mkp/shared/util-app-config';

const { routes } = AppConfig;

/** Helper to build workspace route path */
const workspacePath = (workspaceId: string, ...paths: string[]) =>
  `/${routes.workspace}/${workspaceId}/${paths.join('/')}`;

export const ANY_ORDER_SUMMARY = AppConfig.routes.orderSummary;
export const BOOST_VACANCY = `${routes.credits}/${routes.productsOptions}`;
export const BOOST_VACANCY_SUMMARY = `${routes.credits}/${routes.summary}`;
export const BOOST_SUCCESS = `${routes.credits}/${routes.success}`;
export const CLAIM_COMPANY = AppConfig.routes.claimCompany;
export const CLAIM_MANAGEMENT = routes.claimManagement;
export const CLAIM_MANAGEMENT_DETAILS_WITH_ID = `${CLAIM_MANAGEMENT}/`; // with ID appended
export const CREATE_INVITE = AppConfig.routes.createInvite;
export const EXTEND = AppConfig.routes.extend;
export const CREATE_VACANCY = `${AppConfig.routes.vacancy}/${AppConfig.routes.new}`;
export const CREATE_VACANCY_GROUP = `${AppConfig.routes.vacancyGroup}/${AppConfig.routes.create}`;
export const DASHBOARD = AppConfig.routes.dashboard;
export const EDIT_VACANCY = `${AppConfig.routes.vacancy}/${AppConfig.routes.edit}`;
export const LANDING_PAGE = AppConfig.routes.home;
export const LOGIN_PAGE = AppConfig.routes.login;
export const ME = AppConfig.routes.me;
export const MY_USER_PROFILE = `${AppConfig.routes.user}/${AppConfig.routes.me}`;
export const ONBOARDING = AppConfig.routes.onboarding;
export const PREVIEW_VACANCY = `${AppConfig.routes.vacancy}/${AppConfig.routes.preview}`;

// The detail (/vacancy/:id), edit (/vacancy/:id/edit) and publish (/vacancy/:id/publish/*) urls
// carry the id as a path segment, so no fixed substring identifies them. Match them by shape
// instead. EDIT_VACANCY and PREVIEW_VACANCY above stay as page-name identities — goBackMap keys and
// mapUrlToPageName return values — while these do the matching. Leading-slash agnostic and
// query-tolerant. `new` is excluded from the detail pattern so the create form is not read as a
// detail page; CREATE_VACANCY handles that one.
export const EDIT_VACANCY_PATTERN = /vacancy\/[^/?]+\/edit(?:$|\?)/;
export const PUBLISH_VACANCY_PATTERN = /vacancy\/[^/?]+\/publish(?:$|[/?])/;
export const VACANCY_DETAIL_PATTERN = /vacancy\/(?!new(?:$|\?))[^/?]+(?:$|\?)/;
export const PUBLISH_VACANCY = `${AppConfig.routes.vacancy}/${AppConfig.routes.publish}/`;
export const SELECT_WORKSPACE = AppConfig.routes.selectAccountMembership;
export const INCOMPLETE_ONBOARDING = AppConfig.routes.incompleteOnboarding;
export const REDEEM_INVITE = AppConfig.routes.redeemInvite;
export const INVALID_INVITE = AppConfig.routes.invalidInvite;
export const PURCHASE_CREDITS = AppConfig.routes.purchaseCredits;
export const PURCHASE_HISTORY = AppConfig.routes.purchaseHistory;
export const PURCHASE_CREDITS_COMPARISON = AppConfig.routes.purchaseCreditsCommparison;
export const APPLICATIONS = AppConfig.routes.applications;
export const APPLICATIONS_MOBILE_WITH_QUERY = `${APPLICATIONS}/`;
export const PAY_PER_INVITE = AppConfig.routes.payPerInvite;

export const VERIFY_IDENTITY = AppConfig.routes.verifyIdentity;

export const BO_CLAIM_COMPANY = `${routes.claimManagement}/${routes.claimCompany}`;
export const CREATE_COMPANY = `${routes.claimManagement}/${routes.claimCompany}/${AppConfig.routes.createCompany}`;

export const COMPANY_PROFILE_WITH_ID = `${AppConfig.routes.company}/edit/:companyId`;
export const VACANCY_GROUP_FORM = `${AppConfig.routes.vacancyGroup}`;

export const DESIGN_SYSTEM = AppConfig.routes.ui;

/** Returns the credit management route for a given workspace */
export const getCreditManagementRoute = (workspaceId: string) =>
  workspacePath(workspaceId, AppConfig.routes.creditManagement);

/** Returns the purchase credits route for a given workspace */
export const getPurchaseCreditsRoute = (workspaceId: string) =>
  workspacePath(workspaceId, AppConfig.routes.creditManagement, AppConfig.routes.purchaseCredits);

/** Returns the purchase history route for a given workspace */
export const getPurchaseHistoryRoute = (workspaceId: string) =>
  workspacePath(workspaceId, AppConfig.routes.creditManagement, AppConfig.routes.purchaseHistory);

/** Returns the vacancy list route for a given workspace */
export const getVacancyListRoute = (workspaceId: string) =>
  workspacePath(workspaceId, AppConfig.routes.vacancies);

export const urlMatchesAnyPage = (
  pages: (string | RegExp)[],
  url: string,
  excludedPages: (string | RegExp)[] = []
) => stringContains(url, pages) && !stringContains(url, excludedPages);

const stringContains = (str: string, matchers: (string | RegExp)[]) =>
  matchers.some((matcher) =>
    typeof matcher === 'string' ? str.includes(matcher) : matcher.test(str)
  );

export const removeQueryParams = (url: string) => url.split('?')[0];
